import e from"../internals/well-known-symbol-define.js";var o=e;o("iterator");
